import * as React from "react"
import colors from "../../theme/colors"

interface Props {
  extended?: boolean
}

const Extend: React.SFC<Props> = ({ extended = false }) => (
  <svg width={24} height={24}>
    <path
      fill={colors.main.backgroundColor.PRIMARY}
      d={
        extended
          ? "M18 13H6c-.55 0-1-.45-1-1s.45-1 1-1h12c.55 0 1 .45 1 1s-.45 1-1 1z"
          : "M18 13h-5v5c0 .55-.45 1-1 1s-1-.45-1-1v-5H6c-.55 0-1-.45-1-1s.45-1 1-1h5V6c0-.55.45-1 1-1s1 .45 1 1v5h5c.55 0 1 .45 1 1s-.45 1-1 1z"
      }
    />
  </svg>
)

export default Extend
